import { VictoryArea } from 'victory';
import chroma from 'chroma-js';
import { SingleDimensionInfo } from './lineGraph.types';

const getGradientStops = ({
	min,
	max,
	color,
}: {
	min: number;
	max: number;
	color: string;
}) => {
	const beforeCutOffPercentage = max === min ? 100 : (max / (max - min)) * 100;
	const afterCutOffPercentage = 100 - beforeCutOffPercentage;
	const maxOpacity = 0.2;
	const minOpacity = 0.01;
	const maxColor = chroma.mix('white', color, maxOpacity).hex();
	const minColor = chroma.mix('white', color, minOpacity).hex();
	const startOffsetRatio = 0.2;
	const endOffsetRatio = 0.5;
	const stops = [
		{ offset: beforeCutOffPercentage * startOffsetRatio, stopColor: maxColor },
		{ offset: beforeCutOffPercentage * endOffsetRatio, stopColor: minColor },
		{
			offset: 100 - afterCutOffPercentage * endOffsetRatio,
			stopColor: minColor,
		},
		{
			offset: 100 - afterCutOffPercentage * startOffsetRatio,
			stopColor: maxColor,
		},
	];

	return stops;
};

const LinearGradient = ({
	id,
	children,
}: {
	id: string;
	children: React.ReactNode;
}) => {
	return (
		<linearGradient id={id} x1="0" x2="0" y1="0" y2="1">
			{children}
		</linearGradient>
	);
};

export const Gradient = ({
	filteredDimensionData,
	chartColor: { color, colorId },
	min = 0,
	max,
}: SingleDimensionInfo) => {
	const stops = getGradientStops({ min, max, color });

	return [
		<VictoryArea
			name={`area-${colorId}`}
			key={`area-${colorId}`}
			data={filteredDimensionData}
			style={{
				data: {
					fill: `url(#${colorId})`,
				},
			}}
		/>,
		<LinearGradient key={colorId} id={colorId}>
			{stops.map(({ offset, stopColor }, index) => {
				return <stop key={index} offset={`${offset}%`} stopColor={stopColor} />;
			})}
		</LinearGradient>,
	];
};
